import { SxProps } from "@mui/system";

export const root: SxProps = {
  minHeight: "calc(100vh - 130px)",
  display: "flex",
  flex: "1 1 100%",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
};
